import { Injectable } from '@angular/core';
import {
	AttestationFinDeFormation,
	AttestationFinDeFormationInterface,
	AttestationFinDeFormationPayload,
} from './attestation-fin-de-formation';
import { AttestationFinDeFormationSearchParamsInterface } from './attestation-fin-de-formation-search-params';
import { BaseModelService } from '@app/abstracts';
@Injectable()
export class AttestationFinDeFormationService extends BaseModelService<
	AttestationFinDeFormation,
	AttestationFinDeFormationInterface,
	AttestationFinDeFormationPayload,
	AttestationFinDeFormationSearchParamsInterface
> {
	/** @inheritDoc */
	protected path(): string {
		return 'attestation-fin-de-formation';
	}
	/** @inheritDoc */
	protected new(
		object: AttestationFinDeFormationInterface
	): AttestationFinDeFormation {
		return new AttestationFinDeFormation(object);
	}
}
